import { BaseService } from '../../../../../core/services/base.service';
import { StageId } from '../models/stages.model';
import { StageWithTemplates } from '../models/templates.model';

export class StagesService {
  static async GetStages(
    companyId: string,
    clientId: string,
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      filter?: string;
    }
  ): Promise<{ content: StageId[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    return await BaseService.Get(
      `/companies/${companyId}/clients/${clientId}/statuses${query}`
    );
  }

  static async GetById(
    companyId: string,
    clientId: string,
    statusId: string,
    spinner: boolean = true
  ): Promise<StageWithTemplates> {
    return await BaseService.Get(
      `/companies/${companyId}/clients/${clientId}/statuses/${statusId}`,
      undefined,
      spinner
    );
  }

  static async PatchOrder(
    companyId: string,
    clientId: string,
    order: { statusId: string; order: number }[]
  ): Promise<StageId[]> {
    return await BaseService.Patch(
      `/companies/${companyId}/clients/${clientId}/statuses`,
      order
    );
  }
}
